export type AssetType = "src" | "background-image";

export const onEachComponent = (root, cb) => {
  const components = root.components();
  cb(root);
  if (components) {
    components.forEach(c => onEachComponent(c, cb));
  }
};

export const onEachAssetImage = (component: any, cb: (asset: string, type: AssetType) => void) => {
  const bg: string | undefined = component.getStyle()["background-image"];
  const src: string | undefined = component.get("src");
  if (bg) {
    const regexp = /(url\((["'])?)([^"']+)((["'])?\))/;
    const [, , , url] = bg.match(regexp) || [];
    cb(url, "background-image");
  }
  src && cb(src, "src");
};
